import { Box } from '@chakra-ui/react'
import { Page } from 'components/Layout/Page'
import { Text } from 'components/Text'

export const Farming = () => {
  return (
    <Page>
      <Box width='full'>
        <Text translation='defi.farming' />
      </Box>
    </Page>
  )
}
